import { render, staticRenderFns } from "./BaseFormPreview.vue?vue&type=template&id=40c0182d&scoped=true&"
import script from "./BaseFormPreview.vue?vue&type=script&lang=js&"
export * from "./BaseFormPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0182d",
  null
  
)

export default component.exports